import React from 'react'
import {ListItem, Typography} from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import Tooltip from '@material-ui/core/Tooltip'
import IServices from '../../../../interfaces/IServices'
import IService from '../../../../interfaces/IService'
import ServiceItem from './ServiceItem'
import useStyles from '../ServicesStyles'
import {ActionData, devices, Quote} from '../../../../services/quote/QuoteProvider'
import {mdBreakpoint, windowWidth} from '../../../../utils/constants/constants'
import { INCENTIVE_BUSINESS_TYPE } from '../../../common/BusinessTypeSwitch/BusinessTypeSwitch'

interface IServiceCategoryItemProps {
    data: IServices,
    serviceNumber: number | null,
    quote: Quote,
    addItem: (item: ActionData) => void,
    removeItem: (item: ActionData) => void,
    changeItem: (item: ActionData) => void
}

const ServiceCategoryItem: React.FunctionComponent<IServiceCategoryItemProps> = props => {
    const {data, addItem, removeItem, changeItem, serviceNumber, quote} = props

    const classes = useStyles()

    return (
        <ListItem className={classes.serviceWrapper}>
            <div className={classes.serviceCategoryHeader}>
                {serviceNumber && (
                    <Typography variant='h1' className={classes.title}>
                        {serviceNumber}. {data.title}
                        {/* {!data.required && <span style={{textTransform: 'lowercase', marginLeft: '5px'}}>
                            ({translate('optional')})
                        </span>}*/}
                    </Typography>
                )}
                {!!data.infoText && (
                    <Tooltip title={data.infoText}
                             enterTouchDelay={0}
                             leaveTouchDelay={3000}
                             placement={windowWidth >= mdBreakpoint ? 'right-start' : 'bottom-start'}
                             classes={{
                                 tooltip: classes.tooltip,
                             }}>
                        <InfoIcon className={classes.infoIcon} />
                    </Tooltip>
                )}
            </div>

            <div className={classes.serviceItemWrapper}>
                {
                    (data.data as IService[]).map((service, index) => {
                        const device = quote.items.find(i => i.id === 'device_one')
                        const selectedItem = quote.items.find(i => i.id === service.id)
                        const resetItem = !selectedItem || devices.includes(service.id) // Only one device can be selected
                        const internetOptionFreeFlag = !!device && service.id === 'option2' && quote.businessType !== INCENTIVE_BUSINESS_TYPE
                        const quantitySelectDisabled = device && device?.quantity > 0 && service.id === 'option2' && quote.businessType !== INCENTIVE_BUSINESS_TYPE
                        if(internetOptionFreeFlag) service.priceInfo = '4,99€/mj nakon 2 mj.'
              
                        return (
                            <ServiceItem key={`serviceItem${index}`}
                                         data={service}
                                         selectedItem={selectedItem}
                                         resetItem={resetItem}
                                         quantitySelectDisabled={quantitySelectDisabled}
                                         showRibbon={(!!device && service.id === 'option2' && quote.businessType !== INCENTIVE_BUSINESS_TYPE) || service.id === 'incentive_2'}
                                         ribbonText={service.id === 'incentive_2' ? 'Godišnja licenca' : '2 mjeseca gratis'}
                                         hideMonthlyLabel={!!device && service.id === 'option2' && quote.businessType !== INCENTIVE_BUSINESS_TYPE}
                                         addItem={addItem}
                                         changeItem={changeItem}
                                         removeItem={removeItem}/>
                        )
                    })
                }
            </div>
        </ListItem>
    )
}

export default ServiceCategoryItem
